import { useState } from "react";
import { DResponsiveWindow } from "../../libs/dweb/DResponsiveWindow";
import { dnetwork, TObject, yahooFin } from "corexxx";
import { DTable } from "../../libs/dweb/DTable";
import { DHook } from "../../libs/common_hooks/DHook";
import { useDAppCommand } from "../../libs/dweb/DAppCommand";
import { DChartStockBar } from "../../libs/dweb/DChartStockBar";
import { DTreeMap } from "../../libs/dweb/DChart";
const symbols = [
  "^IXIC",
  "^SPX",
  "MSFT",
  "AAPL",
  "NVDA",
  "META",
  "AMD",
  "SPY",
  "VUSA.L",
  "GOOG",
  "^NSEBANK",
  "^NSEI",
  "BANKBEES.NS",
  "BANKNIFTY.NS",
];

export function Opertunities() {
  let appComamnd = useDAppCommand();

  let [data, setData] = useState<yahooFin.TStockInfo[]>([]);
  DHook.useAsyncEffect(async () => {
    let resp = await dnetwork.getSimpleStore(
      `${appComamnd.state.simpleStoreEndpoint}/api/utils/trade/ltp?symbols=${symbols.join(",")}`,
    );
    let data = resp.out as yahooFin.TStockInfo[];
    data.sort((a, b) => b.pchange - a.pchange);
    setData(data);
  }, []);

  return (
    <DResponsiveWindow style={{ marginTop: 10 }}>
      <DTreeMap
        data={data.map((x) => ({
          title: `${x.symbol}(${x.pchange.toFixed(2)}%)`,
          value: x.pchange,
        }))}
      />

      <DTable
        style={{ maxHeight: "100%" }}
        data={data}
        columns={[
          {
            field: "symbol",
            format: (x, obj) => `${obj.symbol}(${obj.pchange.toFixed(2)}%)`,
          },
          {
            field: "week52High",
            headerName: "Oppertunities",
            format: (x, obj) =>
              `${(((obj.week52High - obj.ltp) / obj.ltp) * 100).toFixed(2)}%`,
          },
          {
            field: "week52Low",
            headerName: "Max Loss",
            format: (x, obj) =>
              `${(((obj.ltp - obj.week52Low) / obj.ltp) * 100).toFixed(2)}%`,
          },
          {
            field: "week52Low",
            headerName: "Daily Bar",
            formatEx: (x, obj) => (
              <DChartStockBar
                data={{
                  ltp: obj.ltp,
                  low: obj.low,
                  high: obj.high,
                  open: obj.open,
                  close: obj.close,
                  pclose: obj.pclose,
                }}
                config={{ showLtp: true, showPclose: true }}
              />
            ),
          },

          {
            field: "week52Low",
            headerName: "Year Bar",
            formatEx: (x, obj) => (
              <DChartStockBar
                data={{
                  ltp: obj.ltp,
                  low: obj.week52Low,
                  high: obj.week52High,
                  open: obj.open,
                  close: obj.close,
                  pclose: obj.pclose,
                }}
                config={{ showLtp: true, showPclose: false, showPc: false }}
              />
            ),
          },
        ]}
      ></DTable>
    </DResponsiveWindow>
  );
}
